export const RedirectPageData = ['Yatra', 'Podcast', 'Videoclip', 'News', 'Home', 'TravelHome', 'RechargeHome', 'YatraHome', 'Sancharhome', 'ReligiousHome'];